import { render, staticRenderFns } from "./CmgCharitableDonation.vue?vue&type=template&id=58b5dff7&scoped=true&lang=pug"
import script from "./cmg-charitable-donation.ts?vue&type=script&lang=ts&external"
export * from "./cmg-charitable-donation.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCharitableDonation.vue?vue&type=style&index=0&id=58b5dff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5dff7",
  null
  
)

export default component.exports